import { FC } from 'react'

import styled from 'styled-components'

import { OfferModel } from 'src/Redux/api/offersApi'
import { useGetAllEquipmentQuery } from 'src/Redux/api/equipmentApi'
import { Select } from 'src/Components/Select'
import { Input } from 'src/Components/Input/index.tsx'
import { colors } from 'src/Helpers/constants.ts'

import { EquipmentSelection } from './useCreateContract'

const ModelRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
`

const ModelName = styled.span`
  font-weight: 600;
  font-size: 14px;
  text-align: start;
  color: ${colors.thirdGray};
`

const EquipmentSelectsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const EquipmentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: flex-start;
`

const EquipmentField = styled.div`
  flex: 1;
  min-width: 0;
`

interface ModelEquipmentSelectorProps {
  offerModel: OfferModel
  selectedEquipments: EquipmentSelection[]
  onEquipmentSelect: (index: number, equipmentId: number | null) => void
  onWorkTypeChange: (index: number, workType: string) => void
  onShiftsCountChange: (index: number, shiftsCount: number | null) => void
  onMinHoursPerShiftChange: (index: number, minHoursPerShift: number) => void
}

export const ModelEquipmentSelector: FC<ModelEquipmentSelectorProps> = ({
  offerModel,
  selectedEquipments,
  onEquipmentSelect,
  onWorkTypeChange,
  onShiftsCountChange,
  onMinHoursPerShiftChange,
}) => {
  const count = offerModel.count || 1
  const modelId = offerModel.modelId

  const { data: equipmentsData } = useGetAllEquipmentQuery({
    modelId,
  })

  const equipments = equipmentsData?.data || []
  const equipmentOptions = equipments.map((eq) => ({
    value: eq.id.toString(),
    label: eq.registrationNumber || `ID: ${eq.id}`,
  }))

  return (
    <ModelRow>
      <ModelName>{offerModel.model?.name || 'Модель не указана'}</ModelName>

      <EquipmentSelectsWrapper>
        {Array.from({ length: count }).map((_, index) => (
          <EquipmentRow key={index}>
            <EquipmentField>
              <Select
                label={`Экземпляр ${index + 1}`}
                placeholder='Выберите технику'
                data={equipmentOptions}
                searchable
                nothingFoundMessage='Ничего не найдено'
                value={selectedEquipments[index]?.equipmentId?.toString() || ''}
                onChange={(value) => {
                  const equipmentId = value ? parseInt(value) : null
                  onEquipmentSelect(index, equipmentId)
                }}
              />
            </EquipmentField>
            <EquipmentField>
              <Input
                label='Вид работ техники'
                placeholder='Например: строительные работы'
                value={selectedEquipments[index]?.workType || ''}
                onChange={(e) => {
                  onWorkTypeChange(index, e.target.value)
                }}
              />
            </EquipmentField>
            <EquipmentField>
              <Select
                label={'Кол-во смен'}
                placeholder={'Кол-во смен'}
                onChange={(e) => {
                  onShiftsCountChange(index, Number(e))
                }}
                data={['1', '2']}
                defaultValue='1'
                data-testid='equipment-shifts'
                value={String(selectedEquipments[index]?.shiftsCount)}
              />
            </EquipmentField>
            <EquipmentField>
              <Select
                label={'Мин. часов в смене'}
                placeholder={'Выберите часы'}
                onChange={(e) => {
                  onMinHoursPerShiftChange(index, Number(e))
                }}
                data={['8', '10']}
                defaultValue='10'
                data-testid='equipment-min-hours'
                value={String(
                  selectedEquipments[index]?.minHoursPerShift || 10,
                )}
              />
            </EquipmentField>
          </EquipmentRow>
        ))}
      </EquipmentSelectsWrapper>
    </ModelRow>
  )
}
